import { Clipboard, ContentNode, Message, MessageType, StyledFlex, Text, TextView } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { useOptions } from './MedicalDocumentationPasswordDetailsForm.hooks';

type MedicalDocumentationPasswordDetailsFormProps = Readonly<{
   successMessage?: ContentNode;
   filePassword: string;
}>;

export const MedicalDocumentationPasswordDetailsForm = (
   props: MedicalDocumentationPasswordDetailsFormProps
): JSX.Element => {
   const statusOptions = useOptions();

   return (
      <StyledFlex direction={'column'} gap={20}>
         {props.successMessage ? (
            <Message
               testId={'successMessage'}
               type={MessageType.POSITIVE}
               fullWidth
               options={statusOptions}
               displayIndicator
               label={props.successMessage}
            />
         ) : null}
         <StyledFlex direction={'column'}>
            <TextView testId={'label'} label={translationKeys.filePassword} />
            <StyledFlex gap={8} alignItems={'center'}>
               <Text testId={'filePasswordValue'}>{props.filePassword}</Text>
               <Clipboard value={props.filePassword} />
            </StyledFlex>
         </StyledFlex>
      </StyledFlex>
   );
};
